import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { XIcon } from "../../../icons";
const NewPromptModal = ({ isOpen, onClose, onSave, editingPrompt = null, prefillContent = null, }) => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const modalRef = useRef(null);
    // Pre-fill form when editing or when prefillContent is provided
    useEffect(() => {
        if (editingPrompt) {
            setTitle(editingPrompt.title);
            setContent(editingPrompt.content);
        }
        else if (prefillContent) {
            setTitle("");
            setContent(prefillContent);
        }
        else {
            setTitle("");
            setContent("");
        }
    }, [editingPrompt, prefillContent]);
    // Handle ESC key to close modal
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape" && isOpen) {
                onClose();
            }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [isOpen, onClose]);
    // Handle click outside modal to close
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);
    const handleSave = () => {
        if (title.trim() && content.trim()) {
            onSave(title.trim(), content.trim());
            setTitle("");
            setContent("");
        }
    };
    const handleCancel = () => {
        setTitle("");
        setContent("");
        onClose();
    };
    if (!isOpen)
        return null;
    return (_jsx("div", { className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50", children: _jsxs("div", { ref: modalRef, className: "bg-white rounded-xl shadow-[0px_0px_16px_-8px_rgba(0,0,0,0.15),0px_24px_32px_0px_rgba(0,0,0,0.08),0px_16px_24px_0px_rgba(0,0,0,0.06),0px_4px_8px_0px_rgba(0,0,0,0.04),0px_0px_1px_0px_rgba(0,0,0,0.04)] flex flex-col overflow-hidden w-full max-w-[531px]", children: [_jsxs("div", { className: "flex gap-2 h-14 items-center pl-6 pr-3 py-3", children: [_jsx("h2", { className: "flex-1 font-sans font-bold leading-[1.2] text-[19px] text-gray-900 m-0", children: editingPrompt ? "Edit Prompt" : "New Prompt" }), _jsx("button", { onClick: onClose, className: "bg-gray-100 border border-gray-100 flex items-center justify-center overflow-clip rounded-lg size-8 hover:bg-gray-200 transition-colors cursor-pointer", type: "button", "aria-label": "Close", children: _jsx(XIcon, { size: 24, color: "#9CA3AF" }) })] }), _jsxs("div", { className: "flex flex-col gap-3 px-6 pt-3 pb-6", children: [_jsx("div", { className: "flex flex-col gap-0.5", children: _jsx("input", { type: "text", value: title, onChange: (e) => setTitle(e.target.value), placeholder: "Title", className: "bg-white border border-gray-300 rounded-lg px-2 py-[5px] h-12 font-sans font-normal text-[13px] text-gray-900 placeholder:text-gray-500 focus:outline-none focus:border-primary-purple-70 w-full" }) }), _jsxs("div", { className: "relative", children: [_jsx("textarea", { value: content, onChange: (e) => setContent(e.target.value), placeholder: "Write prompt here...", className: "bg-white border border-gray-300 rounded-lg px-[22.5px] py-5 h-[111px] font-sans font-normal text-[13px] text-gray-900 placeholder:text-gray-500 focus:outline-none focus:border-primary-purple-70 w-full resize-none" }), _jsx("div", { className: "absolute bottom-1 right-1 pointer-events-none", children: _jsx("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M8 8V0L0 8H8Z", fill: "#E5E7EB" }) }) })] })] }), _jsxs("div", { className: "bg-white border-t border-gray-300 flex items-center justify-between p-3", children: [_jsx("button", { onClick: handleCancel, className: "bg-transparent border border-gray-300 rounded-lg px-5 py-1 flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer", type: "button", children: _jsx("span", { className: "font-sans font-bold text-[15px] text-gray-800 leading-[1.2] py-[11px]", children: "Cancel" }) }), _jsx("button", { onClick: handleSave, disabled: !title.trim() || !content.trim(), className: "bg-primary-purple-70 rounded-lg px-5 py-1 flex items-center justify-center hover:bg-primary-purple-80 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed", type: "button", children: _jsx("span", { className: "font-sans font-bold text-[15px] text-white leading-[1.2] py-[11px]", children: "Save" }) })] })] }) }));
};
export default NewPromptModal;
